import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { positioningRows } from '../data/howItWorks';
export function Positioning() {
  return <section aria-labelledby="positioning-title" className="bg-ocean text-white" data-id="element-178" data-mp="1opjt232aoot2">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 py-16 sm:py-20 lg:grid-cols-[1fr_1.2fr] lg:gap-16" style={{
      paddingTop: "18px",
      paddingBottom: "24px"
    }} data-id="element-179" data-mp="1tmtru9bkqctk">
        <div data-id="element-180" data-mp="23epsns51oh1h">
          <h2 id="positioning-title" className="font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-181" data-mp="23d4w5wz66o0z">
            This is not another generic AI ebook.
          </h2>
          <p className="mt-3 text-lg font-semibold text-cyan" data-id="element-182" data-mp="2cf4gay5he885">It’s a practical workflow system.</p>
          <div className="mt-8 space-y-4" data-id="element-183" data-mp="2hdpeks16ahty">
            <div data-id="element-184" data-mp="2hdfnf14e64mo">
              <p className="text-xs font-bold uppercase tracking-wider text-white/50" data-id="element-185" data-mp="2hbv4y9vcqc56">Instead of</p>
              <p className="mt-1 text-base italic text-white/60" data-id="element-186" data-mp="i2y3juwxvjdq">“Give me 10 real estate prompts.”</p>
            </div>
            <div data-id="element-187" data-mp="yqb01ej4cvoz">
              <p className="text-xs font-bold uppercase tracking-wider text-gold" data-id="element-188" data-mp="yqukp305ly6p">You get</p>
              <p className="mt-1 text-base font-semibold text-white" data-id="element-189" data-mp="tzumzvj7nc35">A structured library organized around the work you actually do.</p>
            </div>
          </div>
        </div>

        <ul className="grid gap-x-10 sm:grid-cols-2" data-id="element-190" data-mp="pvmzu2sei471">
          {positioningRows.map(r => <li key={r.label} className="flex items-center justify-between gap-4 border-t border-white/10 py-5" data-id="element-191" data-mp="kwthnx265p0j">
              <span className="font-display text-sm font-black uppercase tracking-[0.14em] text-gold" data-id="element-192" data-mp="1hmue8i8s59se">{r.label}</span>
              <span className="flex items-center gap-2 text-right text-sm text-white/85" data-id="element-193" data-mp="18o8pu6gmn0jp">
                <ArrowRightIcon className="h-3.5 w-3.5 shrink-0 text-cyan" aria-hidden="true" data-id="element-194" data-mp="13pe714intbzl" />
                {r.outcome}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}